import {FreeDeliverySection_InfoMessage} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/basket_mov.types';
import {Alert, COLORS, GenericIconName} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

interface FreeDeliverySectionInfoMessageProps {
  className?: string;
  infoMessage?: FreeDeliverySection_InfoMessage;
}

export const FreeDeliverySectionInfoMessage = ({
  className,
  infoMessage,
  ref,
}: FreeDeliverySectionInfoMessageProps & {ref?: React.Ref<HTMLDivElement>}) => {
  if (!infoMessage) {
    return null;
  }

  return (
    <div
      data-testid="freeDeliveryUnlockedMessage"
      ref={ref}
      className={className}
    >
      <StyledAlert
        type="CUSTOM"
        content={infoMessage.text}
        customConfig={{
          backgroundColor: infoMessage.backgroundColor,
          borderColor: infoMessage.foregroundColor,
          icon: {
            asset: GenericIconName.UspFreeShipping,
            size: 'SS',
            color: COLORS['Fill.Black'],
          },
        }}
      />
    </div>
  );
};

const StyledAlert = styled(Alert)`
  & > div {
    margin: auto;
  }
`;
